import * as React from 'react';
import { TDirection } from '@cian/frontend-newbuilding-carousel-component';
import { ArrowL16, ArrowR16 } from '@cian/ui-kit/prev';
import { clsx } from 'clsx';
import * as styles from './Arrow.css';

interface IArrowProps {
  direction: TDirection;
  disabled: boolean;
  clickHandler?(direction: TDirection): void;
}

export function Arrow({ direction, disabled, clickHandler }: IArrowProps) {
  return (
    <div
      className={clsx(styles['click_area'], direction < 0 && styles['click_area--left'])}
      onClick={() => {
        return clickHandler && !disabled && clickHandler(direction);
      }}
      data-testid="Arrow"
    >
      <div className={clsx(styles['background'], disabled && styles['click_area--disabled'])}>
        <div className={styles['icon_container']}>
          {direction < 0 ? <ArrowL16 color={'gray_icons_100'} /> : <ArrowR16 color={'gray_icons_100'} />}
        </div>
      </div>
    </div>
  );
}
